export enum AssetsPermissionsV2 {
    ViewDetails          = 'Assets.ViewDetails',
    ViewDetailsDocuments = 'Assets.ViewDetailsDocuments',
    ViewList             = 'Assets.ViewList',
    CreateCase           = 'Assets.CreateCase',
    ExportList           = 'Assets.ExportList',
    ReportDataIssue      = 'Assets.ReportDataIssue',
}

export enum CasesPermissionsV2 {
    ViewDetails             = 'Cases.ViewDetails',
    ViewList                = 'Cases.ViewList',
    CasesViewMyCases        = 'Cases.ViewMyCases',
    CasesViewMyCompanyCases = 'Cases.ViewMyCompanyCases',
    Create                  = 'Cases.Create',
    Resolution              = 'Cases.Resolution',
}

export enum AgreementsPermissionsV2 {
    ViewDetails      = 'Agreements.ViewDetails',
    ViewList         = 'Agreements.ViewList',
    ViewContacts     = 'Agreements.ViewContacts',
    ViewRelatedCases = 'Agreements.ViewRelatedCases',
    ViewRelatedSites = 'Agreements.ViewRelatedSites',
    ExportDetails    = 'Agreements.ExportDetails',
}


export enum HomePermissionsV2 {
    ViewQuickAccessTiles           = 'Home.ViewQuickAccessTiles',
    ViewCSPQuickAccessTile         = 'Home.ViewCSPQuickAccessTile',
    ViewHEPowerShopQuickAccessTile = 'Home.ViewHEPowerShopQuickAccessTile',
    ViewPSAQuickAccessTile         = 'Home.ViewPSAQuickAccessTile',
}

export enum SitesPermissionsV2 {
    View            = 'Sites.View',
    ViewAssetsTree  = 'Sites.ViewAssetsTree',
    ExportList      = 'Sites.ExportList',
    ExportDetails   = 'Sites.ExportDetails',
    EditContact     = 'Sites.EditContact',
    ReportDataIssue = 'Sites.ReportDataIssue',
}


export enum ResourcesPermissionsV2 {
    CybersecurityView = 'Resources.Cybersecurity.View',
    CybersecurityViewCompliance = 'Resources.Cybersecurity.ViewCompliance',
    CybersecurityViewPatchFiles = 'Resources.Cybersecurity.ViewPatchFiles',
    DocumentationEditIed = 'Resources.Documentation.EditIED',
    DocumentationEditMicroScada = 'Resources.Documentation.EditMicroSCADA',
    DocumentationEditRtu = 'Resources.Documentation.EditRTU',
    DocumentationEditWireless = 'Resources.Documentation.EditWireless',
    DocumentationView = 'Resources.Documentation.View',
    DocumentationViewIed = 'Resources.Documentation.ViewIED',
    DocumentationViewMicroScada = 'Resources.Documentation.ViewMicroSCADA',
    DocumentationViewRtu = 'Resources.Documentation.ViewRTU',
    DocumentationViewWcn = 'Resources.Documentation.WiredCommunicationsNetwork',
    DocumentationViewWcnHtmlDocumentation = 'Resources.Documentation.WiredCommunicationsNetwork.HtmlDocumentation',
    DocumentationViewWcnReturnOfMaterial = 'Resources.Documentation.WiredCommunicationsNetwork.ViewReturnOfMaterial',
    DocumentationViewWcnUploadHtml = 'Resources.Documentation.WiredCommunicationsNetwork.ViewUploadHtml',
    DocumentationViewWireless = 'Resources.Documentation.ViewWireless',
}